import { makeStyles } from 'tss-react/mui'

export const useStyles = makeStyles()(theme => ({
  root: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    width: '100%',
  },
  footerWrapper: {
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    marginRight: theme.spacing(7),
  },
  clearFormButton: {
    marginRight: theme.spacing(3),
  },
  footerCustomClass: {
    height: theme.spacing(8),
    padding: theme.spacing(1.5, 5),
    justifyContent: 'center',
  },
  totalText: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(0.375),
  },
  totalValue: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
  },
  count: {
    fontSize: '14px',
    fontStyle: 'normal',
    fontWeight: 600,
    lineHeight: '20px',
    letterSpacing: '0.1px',
    color: theme.palette.textField.dark,
    fontFamily: theme.typography.fontFamily,
  },
  dollar: {
    fontSize: '12px',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '16px',
    color: theme.palette.labraText.description,
    fontFamily: theme.typography.fontFamily,
  },
}))
